import { Operator } from '@/modules/corporate/modules/database/fields/types';
import {
  getEmptyFieldValue,
  getFilterFieldValue,
} from '@/modules/corporate/modules/database/fields/utils/operators';
import { FilterOperatorEnum } from '@/types/schema';

const TextOperators: Operator[] = [
  {
    labelKey: 'Database:Operators.Equal',
    value: FilterOperatorEnum.Equal,
    getFieldValue: getFilterFieldValue,
  },
  {
    labelKey: 'Database:Operators.NotEqual',
    value: FilterOperatorEnum.NotEqual,
    getFieldValue: getEmptyFieldValue,
  },
];

export default TextOperators;
